import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import type { ReferenceLoader } from '@atlassian/jira-bulk-operations-common';
import { JiraDetailPanel } from '@atlassian/jira-layout-controller';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { Resizer } from '../detail-view/resizer';

type Props = {
	parentWidth: number;
	isOpen: boolean;
	bulkOperationsForm: ReferenceLoader;
};

export const BulkOperationsSidebar = ({ parentWidth, isOpen, bulkOperationsForm }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireResizeAnalytics = useCallback(
		(ratio: number) => {
			const analyticsEvent = createAnalyticsEvent({
				action: 'resized',
				actionSubject: 'bulkMenu',
			});
			fireUIAnalytics(analyticsEvent, 'bulkEdit', { width: ratio });
		},
		[createAnalyticsEvent],
	);

	if (!isOpen) return null;

	return (
		<JiraDetailPanel>
			{(setDetailPanelWidth) => (
				<Resizer
					parentWidth={parentWidth}
					onResize={setDetailPanelWidth}
					onResizeEnd={fireResizeAnalytics}
				>
					<SidebarContainer
						ref={bulkOperationsForm.setRef}
						data-testid="software-backlog.bulk-operations-sidebar.bulkops-sidebar"
					/>
				</Resizer>
			)}
		</JiraDetailPanel>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SidebarContainer = styled.div({
	width: '100%',
});
